import { render, staticRenderFns } from "./QuotationProposalCafezal.vue?vue&type=template&id=53b2b1e6&scoped=true"
import script from "./QuotationProposalCafezal.vue?vue&type=script&lang=js"
export * from "./QuotationProposalCafezal.vue?vue&type=script&lang=js"
import style0 from "./QuotationProposalCafezal.vue?vue&type=style&index=0&id=53b2b1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2b1e6",
  null
  
)

export default component.exports